import axios from "axios";
import * as Sentry from "@sentry/react";

const apiMagicLink = axios.create({
  baseURL: `${process.env.REACT_APP_MAGIC_LINK_LAMBDA_URL}`,
});

apiMagicLink.interceptors.response.use(
  (response) => response,
  (error) => {
    const sentryError = new Error(error.message);
    Sentry.captureException(sentryError, (scope) => {
      scope.setTransactionName(`Magic Link Lambda: ${error.code}`);
      scope.setTag("Magic Link Lambda", error.code);
      scope.setExtra("data", error);
    });
    return Promise.reject(error);
  }
);

export default apiMagicLink;
